<template>
  <div>
    <div class="my-0 w-100 d-flex align-items-center">
      <div class="py-3 mr-2"><strong class="text-info action-label text-nowrap fs-120">{{ test.label }}</strong></div>
      <div class="flex-fill py-3 text-info">
        <strong v-if="test.is_combined">Építsd bele a fenti ajánlásokat egyetlen tárgyba</strong>
        <strong v-if="!test.is_combined">{{ test.action.actionName }}</strong>
      </div>
    </div>
    <b-form-group
      class="my-0 pt-1"
      :invalid-feedback="invalidFeedback"
      :state="state"
    >
      <b-input-group class="d-flex align-items-center">
        <b-form-input
          v-model="subject"
          type="text"
          required
          :state="state"
          @focus="validated = true"
          placeholder="Írd ide a javaslattal kiegészített kontrol tárgyat"
        />
        <b-input-group-append class="ml-2">
          <pulse-effect :active="!test.rated && !test.rating && test.subject.length > 9">
            <button class="btn btn-secondary text-nowrap" @click="() => $emit('rate-test', test)" :disabled="test.rating || test.subject.length < 10">
              Tesztelem <i class="fas fa-caret-right"></i>
            </button>
          </pulse-effect>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <div>
      <div class="d-flex align-items-center">
        <div class="d-flex w-25 my-2 align-items-center">
          <star-rating :value="test.score"/>
          <span v-if="!test.rating">
            <button class="btn btn-sm btn-text text-uppercase text-info text-nowrap ml-3" v-if="test.rated" @click="showDetails = !showDetails">
              Részletek <i class="fas" :class="{'fa-caret-right': !showDetails, 'fa-caret-down': showDetails}"></i>
            </button>
            <span class="font-weight-bold fs-80 text-muted text-nowrap p-2 ml-2" v-if="!test.rated">Még nem tesztelted</span>
          </span>
          <div class="ml-5">
            <b-spinner
              v-if="test.rating"
              variant="info"
              label="Betöltés"
              :style="{width: '1.5rem', height: '1.5rem'}"
            />
          </div>
        </div>
        <div class="d-flex w-50 mr-auto ml-3">
          <div class="font-weight-bold fs-120 text-info border-right pr-2 mt-1">+{{ (test.action.additionalExpectedOpenRate * 100).toFixed(1) }}%</div>
          <div class="small ml-2 align-self-center">
            <p class="mb-0">Várhatóan ekkora pozitív hatással lesz ez a variáció a relatív megnyitási rátára a kontrol tárgyhoz képest.</p>
          </div>
        </div>
      </div>
      <open-fade-down-transition>
        <div class="mt-3" v-if="test.rated" v-show="showDetails">
          <dimensions :categories="categories"  :series="test.dimensions"/>
        </div>
      </open-fade-down-transition>
    </div>
  </div>
</template>
<style>

</style>
<script>
  import StarRating from './partials/StarRating'
  import Dimensions from './partials/Dimensions'
  import OpenFadeDownTransition from '../common/OpenFadeDownTransition'
  import PulseEffect from '../common/PulseEffect'

  //import { computeTestLabel } from '../../util'
  export default {
    components: {
      StarRating,
      Dimensions,
      OpenFadeDownTransition,
      PulseEffect
    },
    props: {
      test: {
        type: Object,
        default: () => ({
          action: {
            id: -1,
            actionName: 'lorem',
            additionalExpectedOpenRate: '0%'
          },
          dimensions: [],
          subject: '',
          is_control: false,
          is_combined: false,
          test_campaign_id: -1,
          score: -1,
          label: '',
          inputState: true,
          rating: false,
          rated: false
        })
      },
      categories: {
        type: Array,
        required: true,
        default: () => ([])
      }
    },
    data() {
      return {
        subject: '',
        showDetails: false,
        validated: false,
      }
    },
    computed: {
      invalidFeedback() {
        if(this.subject.length < 10) {
          return 'A tárgy túl rövid!'
        } else if (this.subject.length == 0) {
          return 'A tárgy megadása kötelező!'
        } else {
          return ''
        }
      },
      state() {
        if(!this.validated) {
          return null
        }

        var state = this.subject.length > 9 ? true : false
        this.$emit('update:inputState', state)
        return state
      }
    },
    watch: {
      subject: function(subject) {
        this.$emit('update:subject', subject)
      },
      'test.subject': {
        immediate: true,
        handler(subject) {
          this.subject = subject
        }
      },
      'test.rating': {
        immediate: true,
        handler(rating) {
          if(rating) {
            this.showDetails = false
          }
        }
      },
      validate(validate) {
        this.validate = true
      }
    },
    mounted() {
    },
    methods: {

    }
  }
</script>